
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.167 0a9.167 9.167 0 110 18.333A9.167 9.167 0 019.167 0zM5.078 15.454a7.452 7.452 0 004.089 1.213 7.464 7.464 0 004.088-1.212l1.291-1.06a7.5 7.5 0 10-10.758 0l1.29 1.059z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.086 11.886c.01-.587.077-1.05.2-1.391.123-.34.375-.718.755-1.132l.969-.999c.414-.468.621-.971.621-1.509 0-.517-.135-.922-.407-1.213-.27-.296-.665-.444-1.183-.444-.503 0-.908.134-1.214.4-.305.266-.458.624-.458 1.072H6c.01-.798.293-1.442.85-1.93C7.414 4.247 8.144 4 9.04 4c.933 0 1.658.252 2.176.755.523.498.784 1.183.784 2.056 0 .863-.4 1.714-1.198 2.552l-.807.8c-.36.399-.54.973-.54 1.723H8.086zm-.059 2.345c0-.222.067-.407.2-.555.138-.153.34-.23.607-.23.266 0 .468.077.606.23a.781.781 0 01.207.555.782.782 0 01-.207.555c-.138.143-.34.214-.606.214-.267 0-.469-.072-.607-.214a.798.798 0 01-.2-.555z","fill":"#fff"}})])
          )
        }
      }
    